$(document).ready(function() {
jQuery(document).on('click', '.remove-btn', function () {
  let variantId = $(this).parent(".cart__item").attr("data-key");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(variantId),
      quantity: 0,
    },
     success: function (data){
            $.ajax({
                type: 'GET',
                dataType: 'jsonp',
                url: '/cart.json',
                success: function(cart){
                    var item_count = cart['item_count'];
                    var total_price = cart['total_price']/100;
                        $('.drawer-count .cart-count').text(item_count);
                        $('.cart__checkout div').text( total_price.toFixed(2)+ '€' );
                  if ( item_count == 0 ) {
                    $(".drawer.cart__drawer-custom").addClass("is-empty");
                  }
                  else if( item_count < 3 ){
                    removeFreeProduct()
                  }
                       }
            });
     }
  });
   $(this).parent(".cart__item").hide(); 
  });
   function removeFreeProduct() {
     let variantId = "40595956301875:20ceee47e721ed11f92becf5b08067a6";
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(variantId),
      quantity: 0,
    },
     success: function (data){
            $.ajax({
                type: 'GET',
                dataType: 'jsonp',
                url: '/cart.json',
                success: function(cart){
                    var total_price = cart['total_price']/100;
                        $('.cart__checkout div').text( total_price.toFixed(2)+ '€' );
                  $(".cart-item-free").hide(); 
                   $(".drawer.cart__drawer-custom").addClass("is-empty");
                                       }
            });
     }
   });
   }

  document.addEventListener("gesturestart", function (e) {
	e.preventDefault();
    document.body.style.zoom = 0.99;
});

document.addEventListener("gesturechange", function (e) {
	e.preventDefault();

  document.body.style.zoom = 0.99;
});
document.addEventListener("gestureend", function (e) {
	  e.preventDefault();
    document.body.style.zoom = 1;
});
 
  });
// ---------------------Remove link -------------
$(document).ready(function() {
jQuery(document).on('click', '.remove-link', function () {
  $(this).siblings(".js-qty__wrapper").find("input.js-qty__num").val(0)
  $(this).siblings(".js-qty__wrapper").find(".js-qty__adjust--minus").click(); 
    return false;
  });

  jQuery(document).on('click', '.remove-item', function () {
    
    $(this).parents(".cart__item--details").find("input.js-qty__num").val(0)
    $(this).parents(".cart__item--details").find(".js-qty__adjust--minus").click(); 
    return false;
  });

   jQuery(document).on('click', '.add-to-cart ', function () {
     // setInterval(function(){ 
     
     $(".drawer.cart__drawer-custom").removeClass("is-empty");
       $(this).siblings(".product-added").css("opacity", "1");


     setTimeout(function() {
       console.log("inside timeout");
       
        $(".product-added").css("opacity", "0");
      }, 5000);
   });
  });

 jQuery(document).on('click', '.jdgm-carousel-number-of-reviews ', function () {
    window.location.href = '/pages/avis-clients';
    return false;
});

$(document).mouseup(function(e) {
    var container = $(".megamenu");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.site-nav__item').removeClass('is-open');
      }
   })

jQuery(document).on('touchend click', ".site-nav__item", function (e) {
$(this).toggleClass("is-open");
  $(this).siblings().removeClass('is-open');
  });

    jQuery(document).ready(function () {
  jQuery(".owl-carousel").owlCarousel({
    slideSpeed: 300,
    paginationSpeed: 400,
    nav: true,
    dots: false,
    loop:false,
    navRewind: false,
    autoplay: false,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 2,
      },
      768: {
        items: 4,
      },
    },
  });
});

